/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kubernetes API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CheckOpenShiftClusterExistsResponse,
  ClusterStatusResponse,
  GetV7KubernetesClusterStatusParams,
  KubernetesClusterResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getClusterStatus
 */
export const getV7KubernetesClusterStatus = (
  params: MaybeRef<GetV7KubernetesClusterStatusParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ClusterStatusResponse>(
    { url: `/api/v7/kubernetes/cluster/status`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7KubernetesClusterStatusQueryKey = (
  params?: MaybeRef<GetV7KubernetesClusterStatusParams>,
) => {
  return ['api', 'v7', 'kubernetes', 'cluster', 'status', ...(params ? [params] : [])] as const;
};

export const getGetV7KubernetesClusterStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7KubernetesClusterStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7KubernetesClusterStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>> = ({
    signal,
  }) => getV7KubernetesClusterStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>,
    TError,
    TData
  >;
};

export type GetV7KubernetesClusterStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>
>;
export type GetV7KubernetesClusterStatusQueryError = ErrorType<unknown>;

/**
 * @summary getClusterStatus
 */

export function useGetV7KubernetesClusterStatus<
  TData = Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7KubernetesClusterStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7KubernetesClusterStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7KubernetesClusterStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getCluster
 */
export const getV7KubernetesClusters = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<KubernetesClusterResponse>(
    { url: `/api/v7/kubernetes/clusters`, method: 'GET', signal },
    options,
  );
};

export const getGetV7KubernetesClustersQueryKey = () => {
  return ['api', 'v7', 'kubernetes', 'clusters'] as const;
};

export const getGetV7KubernetesClustersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7KubernetesClusters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV7KubernetesClusters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7KubernetesClustersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7KubernetesClusters>>> = ({
    signal,
  }) => getV7KubernetesClusters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7KubernetesClusters>>,
    TError,
    TData
  >;
};

export type GetV7KubernetesClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7KubernetesClusters>>
>;
export type GetV7KubernetesClustersQueryError = ErrorType<unknown>;

/**
 * @summary getCluster
 */

export function useGetV7KubernetesClusters<
  TData = Awaited<ReturnType<typeof getV7KubernetesClusters>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7KubernetesClusters>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7KubernetesClustersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary checkOpenShiftClusterExists
 */
export const getV7KubernetesClustersOpenshiftExists = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<CheckOpenShiftClusterExistsResponse>(
    { url: `/api/v7/kubernetes/clusters/openshift/exists`, method: 'GET', signal },
    options,
  );
};

export const getGetV7KubernetesClustersOpenshiftExistsQueryKey = () => {
  return ['api', 'v7', 'kubernetes', 'clusters', 'openshift', 'exists'] as const;
};

export const getGetV7KubernetesClustersOpenshiftExistsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7KubernetesClustersOpenshiftExistsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>
  > = ({ signal }) => getV7KubernetesClustersOpenshiftExists(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>,
    TError,
    TData
  >;
};

export type GetV7KubernetesClustersOpenshiftExistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>
>;
export type GetV7KubernetesClustersOpenshiftExistsQueryError = ErrorType<unknown>;

/**
 * @summary checkOpenShiftClusterExists
 */

export function useGetV7KubernetesClustersOpenshiftExists<
  TData = Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7KubernetesClustersOpenshiftExists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7KubernetesClustersOpenshiftExistsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
